import router from './router'
// import router from "./router/index";
// import { asyncRouterMap, constantRouterMap } from './router/index';
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken,setToken } from '@/utils/auth' // get token from cookie
import Cookies from 'js-cookie'
import configStore from '@/store/configStore'

// import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/account/login','/login','/admin', '/a/'] // no redirect whitelist


router.beforeEach(async(to, from, next) => {
  if (!configStore.getters.baseUrl || !configStore.getters.baseUrl.OPEN_BASE_URL) {
    await configStore.dispatch('init');
  }

  if (!configStore.getters.baseUrl || !configStore.getters.baseUrl.OPEN_BASE_URL) {
    // next('/404');
    // return;
  }   

  // if(Cookies.get('SESSION')&&!getToken()){
  //   setToken(Cookies.get('SESSION'));
  //   await store.dispatch("user/getInfo");
  //   Cookies.remove('SESSION');
  // }else if(Cookies.get('SESSION')&&getToken()){
  //   await store.dispatch("user/getInfo");
  //   Cookies.remove('SESSION');
  // }

  // start progress bar
  if (to.path !== from.path) {
    NProgress.start();
  }

  // set page title
  // document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()
  
  if (hasToken) {
    // router.addRoutes(asyncRouterMap);
    if (to.path === '/account/login'||to.path ==='/account/register') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      const user = store.getters.user
      // store.dispatch('user/updateUnReadCount')
      if (!store.getters.name) {
        await store.dispatch('user/getInfo')
      }
      const hasGetUserPermission = store.getters.permissions
      if (hasGetUserPermission) {
        if(to.meta.permissions){
          if(store.getters.permissions.indexOf(to.meta.permissions)>-1){
            next()
          }else{
            next({name:'404'})
          }
          
        }else{
          next()
        }
      } else {
        try {
          // get user info
          // await store.dispatch('user/getInfo')
          next()
          
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/account/login?redirect=${from.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    if (to.meta.requireAuth === false) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/account/login?redirect=${from.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
